'use client';

import type { RouteMetaPayload } from './routeMeta';

/**
 * Formerly wrote page targeting to Legacy Raptive.
 * On bz, FreestarBootstrapWithRouteMeta consumes RouteMeta.pageTargeting +
 * disableFooterDisplayAd directly — keep this as a stable PageTracking hook.
 */
export function applyRouteMetaTargeting(_payload: RouteMetaPayload): void {}
